import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export class SidenavUtils {
  static orgMenu = (module) => ({
    id: module + 'Org',
    displayName: 'Organizations',
    icon: fas.faGlobe,
    route: module + '/org',
    role: module.toUpperCase() + '_ORG_VIEW',
    precedence: -10000,
    state: { mode: Mode.DETAIL, entityId: 1 },
  });

  static commonMenus = (module, menus = ['subs', 'vals', 'props', 'pluginInfos', 'system', 'closure']) => {
    let configs = [];
    if (menus.includes('subs')) configs.push(this.subMenu(module));
    if (menus.includes('vals')) configs.push(this.valMenu(module));
    if (menus.includes('props')) configs.push(this.propsMenu(module));
    if (menus.includes('closure')) configs.push(this.createClosureItem(module));
    if (menus.includes('pluginInfos')) configs.push(this.pluginInfoMenu(module));
    if (menus.includes('system')) configs.push(this.systemMenu(module));
    return configs;
  };

  static subMenu = (module) => ({
    id: module + 'Sub',
    displayName: 'Submissions',
    icon: fas.faFileUpload,
    route: module + '/sub',
    role: module.toUpperCase() + '_SUB_VIEW',
    precedence: 10001,
  });

  static valMenu = (module) => ({
    id: module + 'Val',
    displayName: 'Validations',
    icon: fas.faShieldCheck,
    route: module + '/val',
    role: module.toUpperCase() + '_VAL_VIEW',
    precedence: 10002,
  });

  static propsMenu = (module) => ({
    id: module + 'Prop',
    displayName: 'Properties',
    role: 'PROP_VIEW',
    icon: fas.faFileCheck,
    route: module + '/prop',
    precedence: 10003,
  });

  static createClosureItem = (module) => ({
    id: module + 'Closure',
    displayName: 'Closures',
    role: module.toUpperCase() + '_CLOSURE_VIEW',
    icon: fas.faCalendar,
    route: module + '/closure',
    precedence: 10005,
  });

  static pluginInfoMenu = (module) => ({
    id: module + 'PluginInfo',
    displayName: 'Plugins',
    icon: fas.faPuzzlePiece,
    route: module + '/plugin-info',
    role: module.toUpperCase() + '_PLUGIN_INFO_VIEW',
    precedence: 10006,
  });

  static systemMenu = (module) => {
    let children = [
      this.metricsMenu(module),
      this.systemInfoMenu(module),
      this.apiDocsMenu(module),
      this.interactMenu(module),
      this.interactLogsMenu(module),
      this.loggerMenu(module),
      this.logFileMenu(module),
    ];

    return {
      id: module + 'SystemMenu',
      displayName: 'System',
      icon: fas.faTools,
      children,
      role: module.toUpperCase() + '_SYSTEM_VIEW',
      precedence: 10007,
    };
  };

  static metricsMenu = (module) => ({
    id: module + 'Metrics',
    displayName: 'Metrics',
    icon: fas.faTools,
    route: module + '/metrics',
    role: module.toUpperCase() + '_METRICS_VIEW',
  });

  static systemInfoMenu = (module) => ({
    id: module + 'Info',
    displayName: 'System Info',
    icon: fas.faTools,
    route: module + '/info',
    role: module.toUpperCase() + '_INFO_VIEW',
  });

  static apiDocsMenu = (module) => ({
    id: module + 'ApiDocs',
    displayName: 'API Docs',
    icon: fas.faBookOpen,
    route: module + '/openapi',
    role: module.toUpperCase() + '_SYSTEM_VIEW',
  });

  static interactMenu = (module) => ({
    id: module + 'Interact',
    displayName: 'Interact',
    icon: fas.faWrench,
    route: module + '/interact',
    role: module.toUpperCase() + '_INTERACT_VIEW',
  });

  static interactLogsMenu = (module) => ({
    id: module + 'InteractLogs',
    displayName: 'Interact Logs',
    icon: fas.faList,
    route: module + '/interact-logs',
    role: module.toUpperCase() + '_INTERACT_VIEW',
  });

  static loggerMenu = (module) => ({
    id: module + 'Logger',
    displayName: 'Loggers',
    icon: fas.faStream,
    route: module + '/loggers',
    role: module.toUpperCase() + '_LOGGERS_VIEW',
  });

  static logFileMenu = (module) => ({
    id: module + 'LogFile',
    displayName: 'Log File',
    icon: fas.faStream,
    route: module + '/log-file',
    role: module.toUpperCase() + '_LOG_FILE_VIEW',
  });
}
